import { useTranslation } from 'react-i18next';
import { trDisplay } from '../../i18n';
import React from 'react';
import { InfoTooltip, MobileTooltip } from '../ui/tooltip';
import { SWR_HELP } from './swrHelpContent';

// A common editorial format for SWR explanations, using the existing tooltip controls.
export const SWRHelpContent = ({ topic, title, meaning, usage, details, children }) => {
  useTranslation();
  const copy = topic ? SWR_HELP[topic] : { title, meaning, usage };
  return (
    <div className="space-y-2 text-left text-sm leading-relaxed" data-swr-help={topic || 'contextual'}>
      <p className="font-semibold">{trDisplay(copy.title)}</p>
      <p>{trDisplay(copy.meaning)}</p>
      {details}
      <p><strong>{trDisplay("Come usarlo: ")}</strong>{trDisplay(copy.usage)}</p>
      {trDisplay(children)}
    </div>
  );
};

export const SWRHelp = ({ topic, content, side = 'right', children, iconClassName,
  triggerLabel, triggerClassName, contentClassName, buttonTrigger = false, delayDuration }) => {
  useTranslation();
  const explanation = content || <SWRHelpContent topic={topic} />;
  return children ? (
    <MobileTooltip content={explanation} side={side} contentClassName={contentClassName}>{trDisplay(children)}</MobileTooltip>
  ) : (
    <InfoTooltip content={explanation} side={side}
      ariaLabel={triggerLabel} className={triggerClassName} buttonTrigger={buttonTrigger} delayDuration={delayDuration}
      contentClassName={contentClassName}
      iconClassName={iconClassName || 'h-4 w-4 text-slate-400 hover:text-slate-600'} />
  );
};
